import enums from '../../controllers/enums'

const tipoPerfilOperador = enums.TipoOperadorRetaguarda

const rotaGeral = [
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/',
    menu: true,
    meta: {
      role: [tipoPerfilOperador.nenhum]
    }
  },
  {
    title: 'Onboarding',
    icon: 'fas fa-user-plus',
    path: '/onboarding/',
    dir: 'views/onboarding/',
    menu: true,
    meta: {
      roles: [tipoPerfilOperador.administrador],
      allRolesRequired: true
    },
    items: [
      {
        path: 'Conta/',
        view: 'Conta',
        title: 'Conta',
        menu: true,
        meta: {
          // role: ['Nenhum']
        },
      },
    ]
  },
  {
    title: 'Cadastros',
    icon: 'fas fa-edit',
    path: '/cadastros/',
    dir: 'views/cadastros/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'correntista',
        view: 'Correntista',
        title: 'Correntistas',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'contas',
        view: 'Conta',
        title: 'Contas',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'cedente',
        view: 'Cedente',
        title: 'Cedente',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'cedente-carteira',
        view: 'CedenteCarteira',
        title: 'Cedentes x Carteiras',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'operador-front-end',
        view: 'OperadorFrontEnd',
        title: 'Operador Frontend',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'operador-retaguarda',
        view: 'OperadorRetaguarda',
        title: 'Operador Retaguarda',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta],
          allRolesRequired: true,
          parameters: ['operadorRetaguardaHabilitado']
        }
      },
      {
        path: 'operador-onboarding-externo',
        view: 'OperadorOnboardingExterno',
        title: 'Operador Onboarding Externo',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'split',
        view: 'Split',
        title: 'Split',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador]
        }
      },
      {
        path: 'tarifario',
        view: 'Tarifario',
        title: 'Tarifário',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'tarifa-recorrente',
        view: 'TarifaRecorrente',
        title: 'Tarifa Recorrente',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.consulta]
        }
      },
      {
        path: 'transferenciaprogramada/',
        title: 'Transferência Programada',
        dir: 'TransferenciaProgramada/',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
        },
        items: [
          {
            path: 'geral',
            view: 'RepasseSaldoConta',
            title: 'Geral',
            dir: 'Geral/',
            menu: true,
            meta: {
              roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
            }
          },
          {
            path: 'logs',
            title: 'Logs',
            dir: 'Logs',
            menu: true,
            meta: {
              roles: ['Administrador']
            },
            items: [
              {
                path: 'geral',
                view: 'Geral',
                title: 'Geral',
                dir: '/',
                menu: true,
                meta: {
                  roles: ['Administrador']
                }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    title: 'Consultas',
    icon: 'fas fa-search',
    path: '/consultas/',
    dir: 'views/consultas/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'extrato',
        view: 'Extrato',
        title: 'Extrato',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'agendamentos',
        view: 'Agendamentos',
        title: 'Transações Agendadas',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'aprovacoes',
        view: 'Aprovacoes',
        title: 'Aprovações de Transações',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'logtransacionalcartao',
        view: 'LogTransacionalCartao',
        title: 'Log Transacional Cartão',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      }
    ]
  },
  {
    title: 'Processos',
    icon: 'fas fa-tasks',
    path: '/processos/',
    dir: 'views/processos/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'comprovante',
        view: 'Comprovante',
        title: '2ª Via de Comprovantes',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'cnab/',
        title: 'CNAB',
        dir: 'cnab/',
        menu: true,
        meta: {
          // role: ['Nenhum']
        },
        items: [
          {
            path: '400/',
            title: '400',
            dir: '400/',
            menu: true,
            meta: {
              // role: ['Nenhum']
            },
            items: [
              {
                path: 'importacao',
                view: 'Importacao',
                title: 'Importação',
                menu: true,
                meta: {
                  // role: ['Nenhum']
                }
              },
              {
                path: 'exportacao',
                view: 'Exportacao',
                title: 'Exportação',
                menu: true,
                meta: {
                  // role: ['Nenhum']
                }
              }
            ]
          },
        ]
      }
    ]
  },
  {
    title: 'Boletos',
    icon: 'fas fa-file-invoice-dollar',
    path: '/dda/',
    dir: 'views/dda/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'registroboleto',
        view: 'RegistroBoleto',
        title: 'Registro Boleto',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'consultaboleto',
        view: 'ConsultaBoleto',
        title: 'Consulta Boleto',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'alteracaoboleto',
        view: 'AlteracaoBoleto',
        title: 'Alteração Boletos',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'cancelarboletos',
        view: 'CancelarBoleto',
        title: 'Cancelar Boletos',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        title: 'DDA',
        path: 'pagadoreletronico/',
        dir: 'pagadoreletronico/',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
        },
        items: [
          {
            path: 'adesao',
            view: 'Adesao',
            title: 'Adesão',
            menu: true,
            meta: {
              roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
            }
          },
          {
            path: 'consulta',
            view: 'Consulta',
            title: 'Consulta',
            menu: true,
            meta: {
              roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
            }
          }
        ]
      },
      {
        title: 'Protesto de Boleto',
        path: 'ProtestoBoleto/',
        dir: 'protestoBoleto/',
        menu: true,
        meta: {
          roles: ['Administrador']
        },
        items: [
          {
            path: 'consultar',
            view: 'BoletosProtestados',
            title: 'Consulta',
            menu: true,
            meta: {
              roles: ['Administrador']
            }
          },
          {
            path: 'protestar',
            view: 'ProtestarBoleto',
            title: 'Protestar',
            menu: true,
            meta: {
              roles: ['Administrador']
            }
          }
        ]
      }
    ]
  },
  {
    title: 'Consulta Operacional',
    icon: 'fas fa-briefcase',
    path: '/consultaoperacional/',
    dir: 'views/consultaoperacional/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'movporconta',
        view: 'MovPorConta',
        title: 'Movimentações por Conta',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'relatoriosaldo',
        view: 'RelatorioSaldo',
        title: 'Relatório de Saldo',
        menu: true,
        meta: {
          roles: [tipoPerfilOperador.administrador, tipoPerfilOperador.subparceiro]
        }
      },
      {
        path: 'relatorioboletoregistrado',
        view: 'RelatorioBoletoRegistrado',
        title: 'Relatório de Boletos Registrados',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'relatoriocontas',
        view: 'RelatorioContas',
        title: 'Relatório de Contas',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'relatoriodivergenciascontas',
        view: 'RelatorioDivergenciasContas',
        title: 'Divergências Cadastrais',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'downloadrelatorio',
        view: 'DownloadRelatorio',
        title: 'Download Relatório',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'relatorioTarifaRecorrente',
        view: 'RelatorioTarifaRecorrente',
        title: 'Relatório Tarifa Recorrente',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      }
    ]
  },
  {
    title: 'Histórico',
    icon: 'fas fa-history',
    path: '/historico/',
    dir: 'views/historico/',
    menu: true,
    meta: {
      // role: ['Nenhum']
    },
    items: [
      {
        path: 'encerramentoconta',
        view: 'HistoricoEncerramento',
        title: 'Contas Encerradas',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      // {
      //   path: 'HistoricoSplit',
      //   view: 'HistoricoSplit',
      //   title: 'Split',
      //   menu: true,
      //   meta: {
      //     // role: ['Nenhum']
      //   }
      // },
      {
        path: 'TarifarioHistorico',
        view: 'TarifarioHistorico',
        title: 'Tarifário',
        menu: true,
        meta: {
          // role: ['Nenhum']
        }
      },
      {
        path: 'onboarding/',
        menu: true,
        view: '',
        title: 'Onboarding',
        meta: {
          // role: ['Nenhum']
        },
        items: [
          {
            path: 'Conta/',
            view: 'HistoricoConta',
            title: 'Conta',
            menu: true,
            meta: {
              // role: ['Nenhum']
            },
          },
        ]
      },
    ]
  },
  {
    path: '/',
    view: 'Login',
    title: 'Login',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/lembrar',
    view: 'Lembrar',
    title: 'Lembrar',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/recuperar',
    view: 'Alterar',
    title: 'Alterar',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/authcompany',
    view: 'AuthCompany',
    title: 'Parceiro',
    dir: 'views/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/mfa/solicitarPermissao',
    view: 'SolicitacaoMfa',
    title: 'Solicitacao MFA',
    dir: 'views/mfa/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/mfa/introducao',
    view: 'IntroducaoMfa',
    title: 'Informações MFA',
    dir: 'views/mfa/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/mfa/validardispositivo',
    view: 'ValidarDispositivoJornada',
    title: 'Validar MFA',
    dir: 'views/mfa/',
    props: true,
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/mfa/registrartoken',
    view: 'RegistarTokenDispositivo',
    title: 'Registar Token',
    dir: 'views/mfa/',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/verificar',
    view: 'Verificar',
    title: 'verificar',
    dir: 'views/',
    menu: false,
    params: true,
    meta: {
      anonymousAuth: true
    }
  }
]


function filterRoutes(routes, onboardingContaHabilitado) {
  return routes
    .filter(route => {
      if (route.path.includes('onboarding')) {
        return onboardingContaHabilitado;
      }      

      if (route.items) {
        route.items = filterRoutes(route.items, onboardingContaHabilitado);
      }
      return true;
    });
}

export default function getFilteredRoutes(habilitado) {
  return filterRoutes(rotaGeral, habilitado);
}
